<template>
  <v-layout row justify-end>
    <v-btn color="success" dark @click.stop="initScan" small round>
      <v-icon left>mdi-barcode-scan</v-icon>
      {{ title }}
    </v-btn>
    <div disabled>
      <DistributionDetailList ref="DistributionList" />
    </div>

    <v-dialog v-model="dialog" scrollable persistent max-width="500">
      <v-card>
        <v-text-field v-model="testBarcode" label="Test barcode" />
        <v-btn @click="onBarcodeScanned(testBarcode)">Insertar codigo</v-btn>
        <v-card-title>
          <v-text-field
            v-model="documentCount"
            :disabled="true"
            type="number"
            value="0"
            :label="$t('scan-component.scanned-document-count')"
            prepend-icon="mdi-barcode-scan"
            class="px-2"
          />
        </v-card-title>
        <v-card-text style="height: 300px;">
          <div v-for="barcode in barcodes" :key="barcode">
            <p>{{ barcode }}</p>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="text-xs-center">
          <v-layout row>
            <v-flex justify-center>
              <v-btn
                color="success"
                dark
                flat
                @click.stop="emitBarcodes"
                round
              >{{ $t('scan-component.finish-scan-button-label') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import i18n from "../../i18n/index";
import DistributionDetailList from "../../views/distribution-detaild-grid/DistributionDetailList";

export default {
  props: {
    title: {
      type: String,
      default: i18n.t("scan-component.start-scan-button-label"),
    },
    checkStatusSticker: {
      type: String,
      default: () => "",
    },
  },
  components: {
    DistributionDetailList,
  },
  data() {
    return {
      dialog: false,
      barcodes: [],
      documentCount: 0,
      counter: 0,
    };
  },
  watch: {
    checkStatusSticker(val, oldVal) {
      console.log(typeof val.split("*")[0])
      // if (val.length > 0) {
      //   val.forEach((element) => {
      if (val.split("*")[1] === 'true') {
        this.barcodes.unshift(val.split("*")[0]);
        this.documentCount++;
      }
      //   });
      // }
    },
  },
  created() {
    window.addEventListener("keydown", (e) => {
      if (e.keyCode === 187) {
        e.preventDefault();
        return;
      }
    });
  },
  destroyed() {
    this.$barcodeScanner.destroy();
  },
  methods: {
    initScan() {
      this.dialog = true;
      this.$barcodeScanner.init(this.onBarcodeScanned);
    },
    async onBarcodeScanned(barcode) {
      if (barcode === "Enter") {
        return;
      }

      if (!this.barcodes.includes(barcode)) {
        console.log(this.barcodes)
        this.$emit("barcode", barcode);
      } else {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("scan-component.barcode-scanned-already"),
        });
      }
    },

    emitBarcodes() {
      this.$barcodeScanner.destroy();
      this.$emit("barcodes", this.barcodes);
      // this.barcodes = [];
      this.documentCount = 0;
      this.counter = 0;
      this.dialog = false;
    },
  },
};
</script>
